export const DIT_REJECTED_STATUS = "5";

export const isDitRejected = status => String(status) === DIT_REJECTED_STATUS;
